<template>
  <b-modal
    id="scheduleModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    class="p-0"
    size="lg"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">{{
          context.ScheduleInterview.schedulename
        }}</span>
      </div>
      <hr />
      <div
        v-if="!showSpinner"
        @click="closeScheduleInterviewModal()"
        class="xMarkCancel"
        style="top: -25px; right: -25px"
      >
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>
      <div class="candidates-view-modal">
        <b-row class="Schedule-view-details jddetails-parent-1">
          <b-col cols="6">
            <div class="topDiv mt-3">
              <label class="fieldsetStyle"
                >Select Date&nbsp;<span class="asterik">*</span></label
              >
              <b-form-datepicker
                v-model="context.$v.ScheduleInterview.date.$model"
                :class="{
                  error:
                    context.$v.ScheduleInterview.date.$error ||
                    (context.ScheduleInterview.date != '' &&
                      rescheduledate == true),
                }"
                :min="dateDisabled"
                locale="en"
                placeholder="Select date"
              ></b-form-datepicker>
              <div
                class="validationicon"
                v-if="
                  context.$v.ScheduleInterview.date.$dirty &&
                  !context.$v.ScheduleInterview.date.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Required',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                class="validationicon"
                v-if="
                  context.ScheduleInterview.date != '' && rescheduledate == true
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Invalid Date Selection',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="topDiv mt-3">
              <label class="fieldsetStyle"
                >Start Time&nbsp;<span class="asterik">*</span></label
              >
              <vue-timepicker
                class="SI-starttime"
                close-on-complete
                :minute-interval="15"
                :hour-range="enabledStartTimeHours"
                :minute-range="enableStartTimedMinutes"
                @change="endtime()"
                v-model="context.$v.ScheduleInterview.startTime.$model"
                :class="{
                  error:
                    context.$v.ScheduleInterview.startTime.$error ||
                    (context.ScheduleInterview.startTime != '' &&
                      rescheduleStartTime == true) ||
                    context.ScheduleInterview.showError == true,
                }"
                placeholder="Start time"
              ></vue-timepicker>
              <div
                class="validationicon"
                v-if="
                  context.$v.ScheduleInterview.startTime.$dirty &&
                  !context.$v.ScheduleInterview.startTime.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Required',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                class="validationicon mr-2"
                v-if="
                  context.ScheduleInterview.startTime != '' &&
                  rescheduleStartTime == true
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Invalid Time Selection',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                class="validationicon mr-2"
                v-if="
                  context.ScheduleInterview.startTime != '' &&
                  context.ScheduleInterview.showError == true
                "
                v-b-popover.hover.top.v-danger="{
                  content: ' please select both minutes and hours',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="topDiv mt-3">
              <label class="fieldsetStyle"
                >End Time&nbsp;<span class="asterik">*</span></label
              >
              <vue-timepicker
                close-on-complete
                class="SI-endtime"
                :minute-interval="15"
                :hour-range="enabledEndTimeHours"
                :minute-range="enabledEndTimeMinutes"
                v-model="context.ScheduleInterview.endTime"
                placeholder="End time"
                :class="{
                  error: context.$v.ScheduleInterview.endTime.$error,
                }"
              ></vue-timepicker>
              <div
                class="validationicon"
                v-if="
                  context.$v.ScheduleInterview.endTime.$dirty &&
                  !context.$v.ScheduleInterview.endTime.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Required',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
        </b-row>

        <template>
          <hr />
          <b-row class="align-items-center">
            <b-col cols="6">
              <div class="externalpanel topDiv">
                <label
                  :class="
                    !isPanelEmpty || isDateTimeEmpty
                      ? 'disabledfieldsetStyle'
                      : 'fieldsetStyle'
                  "
                  >External Panelist
                </label>
                <b-form-tags
                  input-id="tags-basic"
                  class="inputField"
                  invalid-tag-text="Invalid Email"
                  :tag-validator="tagValidator"
                  :class="{
                    'global-disabledField extdisinputField':
                      isDateTimeEmpty ||
                      !isPanelEmpty ||
                      (context.ScheduleInterview.panelist &&
                        Object.keys(context.ScheduleInterview.panelist)
                          .length != 0),
                    inputField: isPanelEmpty || !isDateTimeEmpty,
                  }"
                  remove-on-delete
                  placeholder="Enter Email"
                  v-model="context.ScheduleInterview.externalPanelist"
                  style="max-height: 100px; overflow-y: auto"
                  :disabled="
                    !isPanelEmpty ||
                    isDateTimeEmpty ||
                    (context.ScheduleInterview.panelist &&
                      Object.keys(context.ScheduleInterview.panelist).length !=
                        0)
                  "
                ></b-form-tags>
              </div>
            </b-col>
            <b-col cols="2">
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="mr-2"
                  src="../../../assets/img/jddetails/panel-line.svg"
                  alt=""
                />
                <span class="jd-or-style">OR</span>
                <img
                  class="ml-2"
                  src="../../../assets/img/jddetails/panel-line.svg"
                  alt=""
                />
              </div>
            </b-col>

            <b-col cols="4">
              <div
                v-if="
                  isExternalEmpty &&
                  !isDateTimeEmpty &&
                  (context.requiredPanel ||
                    (!context.requiredPanel && context.userList.length > 0))
                "
                class="
                  jdpanel
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="
                  (panelistsel = context.ScheduleInterview.panelist),
                    openFolderModal('selectpanel'),
                    context.$refs.selectedpanel.getSelctedPanelist()
                "
              >
                <img
                  class="ml-3 pointer"
                  src="../../../assets/img/jddetails/select-panel.svg"
                  alt=""
                />
                <span class="internal-panelist-text mr-5"
                  >Internal Panelist</span
                >
              </div>
              <div
                v-else
                v-b-popover.hover.top="getPopoverText()"
                class="
                  jdpanel-disable
                  d-flex
                  align-items-center
                  justify-content-between
                  defaultCursor
                "
              >
                <img
                  class="ml-3 pointer defaultCursor"
                  src="../../../assets/img/jddetails/select-panel-disable.svg"
                  alt=""
                />
                <span class="internal-panelist-text-disable mr-5"
                  >Internal Panelist</span
                >
              </div>
            </b-col>
          </b-row>

          <b-row
            class="jd-panel-selection ml-0 mr-0 mt-3"
            v-if="
              context.ScheduleInterview.panelist &&
              context.ScheduleInterview.panelist.name
            "
          >
            <span class="p-3 internal-selected-text">
              Internal Panelist
              <div class="">
                <div
                  v-if="context.ScheduleInterview.teamsStatus != '5'"
                  class=""
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      jd-panel-selection-card
                    "
                  >
                    <div class="panel-name">
                      {{ context.ScheduleInterview.panelist.name }}
                    </div>

                    <div>
                      <span
                        v-if="context.ScheduleInterview.teamsStatus == '0'"
                        class="status-text"
                        style="color: #038e00"
                      >
                        <span class="availability-class"> Availability :</span
                        >{{ context.ScheduleInterview.panelistStatus }}</span
                      >

                      <span
                        v-else-if="context.ScheduleInterview.teamsStatus == '1'"
                        class="status-text"
                        style="color: #bdbd01"
                      >
                        <span class="availability-class"> Availability :</span
                        >{{ context.ScheduleInterview.panelistStatus }}</span
                      >
                      <span v-else class="status-text" style="color: red">
                        <span class="availability-class"> Availability :</span
                        >{{ context.ScheduleInterview.panelistStatus }}</span
                      >
                    </div>
                    <div class="pointer" @click="removePanelist">
                      <img
                        src="../../../assets/img/jddetails/removePanlist.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-else-if="context.ScheduleInterview.teamsStatus == '5'"
                  class=""
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      jd-panel-selection-card
                    "
                  >
                    <div class="panel-name">
                      {{ context.ScheduleInterview.panelist.name }}
                    </div>
                    <span class="status-text" style="color: red">
                      <span class="availability-class"> Availability :</span>
                      {{ context.ScheduleInterview.panelistStatus }}
                    </span>
                    <div class="pointer" @click="removePanelist">
                      <img
                        src="../../../assets/img/jddetails/removePanlist.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </b-row>
          <div
            class="asterik mt-2"
            v-if="
              context.ScheduleInterview.errorpanel == true &&
              !context.requiredPanel &&
              context.userList.length == 0
            "
          >
            Please add an External Panelist
          </div>
          <div
            class="asterik mt-2"
            v-else-if="context.ScheduleInterview.errorpanel == true"
          >
            Please add an External Panelist or Select Internal Panelist
          </div>
          <hr />
          <b-row>
            <b-col class="schedule-meeting-style"> Schedule Meeting </b-col>
          </b-row>
        </template>

        <b-row class="mt-3">
          <b-col cols="3">
            <div class="sm-small-txt mb-1">Schedule With</div>
            <div class="position-relative">
              <div
                class="sm-meeting pointer"
                ref="schedule-card"
                :style="
                  context.ScheduleInterview.date == '' ||
                  context.ScheduleInterview.startTime == '' ||
                  (isPanelEmpty && isExternalEmpty)
                    ? 'background-color :#dbdbe2;cursor: default'
                    : ''
                "
                @click="openScheduleCard = !openScheduleCard"
                v-closable="{
                  exclude: ['schedule-card'],
                  handler: 'closeScheduleCard',
                }"
              >
                <div class="d-flex align-items-center">
                  <div>{{ context.ScheduleInterview.selectedOption }}</div>
                  <div>
                    <img
                      v-if="
                        context.ScheduleInterview.selectedOption ==
                        'Microsoft Teams'
                      "
                      class="ml-3"
                      src="../../../assets/img/jddetails/teams.svg"
                      alt=""
                    />
                    <img
                      v-else-if="
                        context.ScheduleInterview.selectedOption == 'VCCL'
                      "
                      class="ml-3"
                      src="../../../assets/img/jddetails/vccl.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div>
                  <img
                    v-if="
                      context.ScheduleInterview.date != '' &&
                      context.ScheduleInterview.startTime != '' &&
                      (!isPanelEmpty || !isExternalEmpty) &&
                      openScheduleCard == true
                    "
                    src="../../../assets/img/jddetails/greyUpDirect.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/jddetails/greyDownDirect.svg"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="sm-meeting-select"
                v-if="
                  context.ScheduleInterview.date != '' &&
                  context.ScheduleInterview.startTime != '' &&
                  (!isPanelEmpty || !isExternalEmpty) &&
                  openScheduleCard == true
                "
              >
                <div
                  @click="
                    !checkingDomain
                      ? ((context.ScheduleInterview.selectedOption =
                          'Microsoft Teams'),
                        (context.ScheduleInterview.withTeams = true),
                        (context.ScheduleInterview.withVccl = false),
                        (openScheduleCard = false),
                        assignLink('Microsoft Teams'),
                        (toolTipTitle = 'Copy'))
                      : ''
                  "
                  :style="checkingDomain ? 'cursor:not-allowed' : ''"
                  :class="
                    context.ScheduleInterview.selectedOption ==
                    'Microsoft Teams'
                      ? ' defaultCursor sm-sel-option p-2 m-1'
                      : 'sm-option p-2 m-1 pointer'
                  "
                >
                  <span :class="checkingDomain ? 'disable-round-add-text ' : ''"
                    >Microsoft Teams</span
                  >
                  <img
                    :style="checkingDomain ? 'opacity:50%' : ''"
                    class="mr-3"
                    src="../../../assets/img/jddetails/teams.svg"
                    alt=""
                  />
                </div>

                <div
                  @click="
                    (context.ScheduleInterview.selectedOption = 'VCCL'),
                      (context.ScheduleInterview.withTeams = false),
                      (context.ScheduleInterview.withVccl = true),
                      (openScheduleCard = false),
                      assignLink('VCCL'),
                      (toolTipTitle = 'Copy')
                  "
                  :class="
                    context.ScheduleInterview.selectedOption == 'VCCL'
                      ? 'sm-sel-option p-2 m-1'
                      : 'sm-option p-2 m-1 pointer'
                  "
                >
                  <span>VCCL</span>
                  <img
                    class="mr-3"
                    src="../../../assets/img/jddetails/vccl.svg"
                    alt=""
                  />
                </div>

                <div
                  @click="
                    (context.ScheduleInterview.selectedOption = 'None'),
                      (context.ScheduleInterview.withTeams = false),
                      (context.ScheduleInterview.withVccl = false),
                      (openScheduleCard = false),
                      assignLink('None');
                    toolTipTitle = 'Copy';
                  "
                  :class="
                    context.ScheduleInterview.selectedOption == 'None'
                      ? ' defaultCursor sm-sel-option p-2 m-1'
                      : 'sm-option p-2 m-1 pointer'
                  "
                >
                  <span>None</span>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="mt-3" cols="8">
            <div class="sm-meetingLink">
              <label style="left: 1.5vw" class="fieldsetStyle"
                >Meeting Link &nbsp;<span class="asterik">*</span></label
              >

              <div class="position-relative">
                <b-form-input
                  class="sm-inputField"
                  id="textarea"
                  type="text"
                  v-model.trim="context.$v.ScheduleInterview.meetingLink.$model"
                  :class="{
                    error: context.$v.ScheduleInterview.meetingLink.$error,
                  }"
                  :disabled="
                    context.ScheduleInterview.withTeams == true ||
                    context.ScheduleInterview.withVccl == true
                  "
                  :placeholder="
                    context.ScheduleInterview.withTeams == true ||
                    context.ScheduleInterview.withVccl == true
                      ? 'Meeting Link'
                      : 'Enter Meeting Link'
                  "
                >
                </b-form-input>
              </div>

              <div
                class="jdDetails-validationicon"
                v-if="
                  context.$v.ScheduleInterview.meetingLink.$dirty &&
                  !context.$v.ScheduleInterview.meetingLink.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Required',
                }"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col cols="1" class="mt-3">
            <p v-if="context.ScheduleInterview.meetingLink == ''">
              <img
                class="mt-1"
                src="../../../assets/img/jddetails/sharecopydisable.svg"
                alt=""
              />
            </p>
            <p v-else @click="copyToClipboard">
              <img
                v-b-tooltip.hover
                :title="toolTipTitle"
                class="pointer mt-1"
                src="../../../assets/img/jddetails/sharecopy.svg"
                alt=""
              />
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="topDiv mt-4">
              <label class="fieldsetStyle">Meeting Summary&nbsp;</label>
              <b-form-textarea
                rows="3"
                max-rows="4"
                class="inputField"
                type="text"
                placeholder="Enter meeting summary"
                v-model.trim="context.ScheduleInterview.meetingSummary"
                :class="{
                  error: !context.$v.ScheduleInterview.meetingSummary.maxLength,
                }"
              >
              </b-form-textarea>
            </div>
            <div
              class="sched-validationicon"
              v-if="!context.$v.ScheduleInterview.meetingSummary.maxLength"
              v-b-popover.hover.top.v-danger="{
                content: 'Should not exceed 1024 characters',
              }"
              variant="primary"
            >
              <img src="../../../assets/deletepopupicon.svg" alt="" />
            </div>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div
        class="d-flex align-items-center mt-3"
        :class="
          context.activeCandidate.kanbanLevel != 'H' &&
          context.activeCandidate.kanbanLevel != 'F' &&
          context.activeCandidate.kanbanLevel != '0' &&
          context.activeCandidate.kanbanScheduled == false
            ? 'justify-content-between '
            : 'justify-content-end'
        "
      >
        <!-- THIS MODAL WAS OPENING BEFORE -->

        <b-button
          class="jdcancelbtn"
          v-b-modal.SelOpsheadFinal
          v-if="
            context.activeCandidate.kanbanLevel != 'H' &&
            context.activeCandidate.kanbanLevel != 'F' &&
            context.activeCandidate.kanbanLevel != '0' &&
            context.activeCandidate.kanbanScheduled == false
          "
          @click="context.ScheduleInterview.selectCand = true"
          >Select candidate</b-button
        >

        <b-button
          :disabled="rescheduleStartTime == true || rescheduledate == true"
          @click="scheduled"
          class="addbtn pr-4 pl-4"
        >
          {{ context.ScheduleInterview.scheduleButton }}
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import { mapGetters } from "vuex";

import "vue2-timepicker/dist/VueTimepicker.css";
import {
  removePanelist,
  openFolderModal,
  changeToolTipTitle,
  endtime,
} from "../helpers";
import { getTeamToken, scheduled } from "../asynchronous";
export default {
  name: "ScheduleModal",
  components: {
    VueTimepicker,
  },
  props: {
    context: Object,
  },
  data() {
    return {
      externalPan: [],
      showSpinner: false,
      toolTipTitle: "Copy",
      openScheduleCard: false,
      selOpt: "",
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      User: "getRoleValues",
    }),
    checkingDomain() {
      const emailDomain = this.User.email.split("@")[1];

      const isNotSimplify3x = emailDomain !== "simplify3x.com";

      return isNotSimplify3x;
    },
    rescheduleStartTime() {
      const scheduleDateTime = new Date(
        `${this.context.ScheduleInterview.date.replace(/-/g, "/")} ${
          this.context.ScheduleInterview.startTime
        }`
      );
      const currentDateTime = new Date();
      return scheduleDateTime < currentDateTime;
    },

    rescheduledate() {
      let result;

      if (this.context.ScheduleInterview.date != "") {
        const options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        };

        const formattedCurrentTime = new Date().toLocaleDateString(
          "en-GB",
          options
        );
        const currentDate2 = formattedCurrentTime.slice(0, -7);
        const reversedDate = this.context.ScheduleInterview.date.replace(
          /-/g,
          "/"
        );
        const formattedDate = reversedDate.split("/").reverse().join("/");

        if (
          this.convertToISOFormat(currentDate2) <=
          this.convertToISOFormat(formattedDate)
        ) {
          result = false;
        } else {
          result = true;
        }
      }
      return result;
    },

    enabledStartTimeHours() {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      const selectedDate = new Date(this.context.ScheduleInterview.date);
      if (
        currentDate.setHours(0, 0, 0, 0) === selectedDate.setHours(0, 0, 0, 0)
      ) {
        return [[currentHour, 23]];
      } else {
        return [[0, 23]];
      }
    },
    enableStartTimedMinutes() {
      const currentDate = new Date();
      const currentMinute = currentDate.getMinutes();
      const currentHour = currentDate.getHours();
      const selectedDate = new Date(this.context.ScheduleInterview.date);
      if (
        parseInt(this.context.ScheduleInterview.startTime.slice(0, 2)) ==
          parseInt(currentHour) &&
        currentDate.setHours(0, 0, 0, 0) === selectedDate.setHours(0, 0, 0, 0)
      ) {
        return [[currentMinute, 59]];
      } else {
        return [[0, 59]];
      }
    },
    enabledEndTimeHours() {
      const selectedStartHour = parseInt(
        this.context.ScheduleInterview.startTime.slice(0, 2)
      );
      return [[selectedStartHour, 23]];
    },
    enabledEndTimeMinutes() {
      const selectedStartMin = parseInt(
        this.context.ScheduleInterview.startTime.slice(3, 6)
      );
      if (
        parseInt(this.context.ScheduleInterview.endTime.slice(0, 2)) ==
        parseInt(this.context.ScheduleInterview.startTime.slice(0, 2))
      ) {
        return [[selectedStartMin + 1, 59]];
      } else {
        return [[0, 59]];
      }
    },
    dateDisabled() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let dd = String(today.getDate()).padStart(2, "0");
      // 15th two months prior
      let minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      minDate.setDate(dd);
      return minDate;
    },
    isDateTimeEmpty() {
      return (
        this.context.ScheduleInterview.date == "" ||
        this.context.ScheduleInterview.startTime == "" ||
        this.context.ScheduleInterview.endTime == ""
      );
    },
    checkEmailType() {
      return this.context.roleValues.email.split("@")[1] === "simplify3x.com";
    },

    checkColumn() {
      if (this.$route.name === "JdDetails" || this.$route.name === "Kanban") {
        return this.checkEmailType ? "8" : "12";
      }
      // Return a default value in case none of the conditions match
      return "12";
    },

    teamsDisableValue() {
      let temp;
      if (
        this.context.ScheduleInterview.date != "" &&
        this.context.ScheduleInterview.startTime != "" &&
        this.context.ScheduleInterview.meetingLink == ""
      ) {
        if (this.isPanelEmpty && this.isExternalEmpty) {
          temp = true;
        } else if (!this.isPanelEmpty || !this.isExternalEmpty) {
          temp = false;
        }
      } else {
        temp = true;
      }
      return temp;
    },
    isPanelEmpty() {
      return Object.keys(this.context.ScheduleInterview.panelist).length == 0;
    },
    isExternalEmpty() {
      return this.context.ScheduleInterview.externalPanelist.length == 0;
    },
  },

  watch: {
    "context.ScheduleInterview.startTime"(newVal) {
      this.selOpt = this.context.ScheduleInterview.selectedOption;
      const minutesPart = newVal.slice(3);
      const hoursPart = newVal.slice(0, 2);

      if (minutesPart == "mm" || hoursPart == "HH") {
        this.context.ScheduleInterview.showError = true;
      } else {
        this.context.ScheduleInterview.showError = false;
      }
    },

    "ScheduleInterview.panelist"() {
      this.context.ScheduleInterview.errorpanel = false;
    },

    externalPan() {
      this.context.ScheduleInterview.errorpanel = false;
    },
  },
  methods: {
    getPopoverText() {
      if (!this.context.requiredPanel || this.context.userList.length > 0) {
        return "You cannot select Internal Panelist to this JD";
      } else {
        return "";
      }
    },
    convertToISOFormat(dateString) {
      const [day, month, year] = dateString.split("/");
      const isoDate = new Date(
        `${year}-${month}-${day}T00:00:00.000Z`
      ).toISOString();
      return isoDate;
    },
    closeScheduleCard() {
      this.openScheduleCard = false;
    },

    removePanelist() {
      removePanelist(this.context);
    },
    openFolderModal(flag) {
      openFolderModal(this.context, flag);
    },
    tagValidator(tag) {
      let regex = /^[a-z0-9_.-]+@([a-z0-9-]+\.)+[a-z]{2,4}$/;
      return tag.match(regex) != null;
    },
    copyToClipboard() {
      try {
        if (this.context.ScheduleInterview.meetingLink !== "") {
          navigator.clipboard.writeText(
            this.context.ScheduleInterview.meetingLink
          );

          this.toolTipTitle = "Copied";
        }
      } catch (error) {
        console.error("Error copying to clipboard:", error);
      }
    },
    changeToolTipTitle() {
      changeToolTipTitle(this.context);
    },
    endtime() {
      endtime(this.context);
    },
    async getTeamsToken() {
      await getTeamToken(this.context);
    },
    async scheduled() {
      await scheduled(this.context, this);
    },

    removeLink() {
      this.context.ScheduleInterview.meetingLink = "";
    },
    assignLink(option) {
      if (this.selOpt == option) {
        if (option == "VCCL") {
          this.context.ScheduleInterview.meetingLink =
            this.context.ScheduleInterview.storeVcclLink;
        } else if (option == "None") {
          this.context.ScheduleInterview.meetingLink =
            this.context.ScheduleInterview.storeNoneLink;
        } else if (option == "Microsoft Teams") {
          this.context.ScheduleInterview.meetingLink =
            this.context.ScheduleInterview.storeLink;
        }
      } else {
        this.context.ScheduleInterview.meetingLink = "";
      }
    },
    assignVcclLink() {
      this.context.ScheduleInterview.meetingLink =
        this.context.ScheduleInterview.storeVcclLink;
    },

    closeScheduleInterviewModal() {
      this.context.scheduleModal = false;
      this.context.clearDetails = true;
      this.context.$bvModal.hide("scheduleModal");
      this.context.$bvModal.hide("schedrejectedmodal");
      this.context.ScheduleInterview.errorpanel = false;
      this.context.ScheduleInterview.externalPanelist = [];
      this.context.externalPan = [];
      this.context.ScheduleInterview.panelist = {};
      this.context.ScheduleInterview.teamsStatus = null;
      this.context.ScheduleInterview.panelistStatus = null;
      this.context.ScheduleInterview.panelist = {};
      this.context.$v.ScheduleInterview.$reset();
      this.context.ScheduleInterview = {
        date: "",
        startTime: "",
        endTime: "",
        meetingLink: "",
        meetingSummary: "",
        externalPanelist: [],
        teams: true,
        panelist: {},
      };
      this.context.disableText = false;
    },
  },
};
</script>

<style scoped>
.jdDetails-validationicon {
  position: absolute;
  top: 6px;
  right: 31px;
  background: var(--bg-white);
}

.disable-round-add-text {
  font-weight: var(--weight-LM);
  font-size: var(--size-13);

  color: #c4c4c4;
}
</style>
